/* eslint-disable */
// AUTO-GENERATED by scripts/gen-lang-index.mjs (via compile:i18n) — do not edit.
import f0 from './base.json';
import f1 from './de.json';
import f2 from './de.terschelling.json';
import f3 from './en.json';
import f4 from './en.terschelling.json';
import f5 from './nl.json';
import f6 from './nl.terschelling.json';

const map = {
    './base.json': f0,
    './de.json': f1,
    './de.terschelling.json': f2,
    './en.json': f3,
    './en.terschelling.json': f4,
    './nl.json': f5,
    './nl.terschelling.json': f6,
} as unknown as Record<string, Record<string, string>>;

const requireContext = Object.assign(
    (key: string): Record<string, string> => {
        if (!(key in map)) {
            throw new Error(`Unknown lang catalog ${key} — expected one of: ${Object.keys(map).join(', ')}`);
        }
        return map[key];
    },
    {
        keys: (): string[] => Object.keys(map),
    }
);

export default requireContext;
